// extracted by mini-css-extract-plugin
export default {"hidden":"CartIndicator__hidden--oFBax","wrapper":"CartIndicator__wrapper--ZGPV0","balance":"CartIndicator__balance--FDov9"};